import queryString from "query-string";
const parsedQs = queryString.parse(window.location.search);

const initialState = {
    activeFeature: null,
    searchBarVisible: false,
    searchedLocation: null,
    activePage: "map",
    allFilters: [],
    activeFilters: [],
    basemap: "ROADMAP",
    viewingFund: parsedQs.fund,
    isFramed: window.self !== window.top,
    isMultiple: false,
    mapType: parsedQs.mapType || "lga",
    internal: parsedQs.internal === "true",
    zoomToNsw: new Date().getTime(), // If this changes, zoom to NSW
    ariaLiveRegionContents: "", // 'Live' text content for screenreader
};

// Reducer
export default (state = initialState, action) => {
    switch (action.type) {
        case "ACTIVE_FEATURE:SET":
            const zoomToNsw = action.payload ? state.zoomToNsw : new Date().getTime();
            return {
                ...state,
                searchedLocation: null,
                activeFeature: action.payload,
                zoomToNsw: zoomToNsw,
                isMultiple: false,
                activeMultipleProject: null,
            };
        case "ARIA_LIVE_REGION:SET":
            console.log("setting aria live: ", action.payload);
            return { ...state, ariaLiveRegionContents: action.payload };
        case "SEARCH_BAR_VISIBLE:SET":
            return { ...state, searchBarVisible: action.payload };
        case "SEARCHED_LOCATION:SET":
            return { ...state, searchedLocation: action.payload };
        case "ACTIVE_PROJECT:SET":
            return {
                ...state,
                activeProject: action.payload,
                isMultiple: false,
                activeMultipleProject: null,
            };
        case "ACTIVE_FILTER:INIT":
            // We're just passed a list of filter names
            // Initialise 'all filters' to this
            const filterNames = action.payload;
            return {
                ...state,
                allFilters: filterNames,
            };
        case "ACTIVE_FILTER:SET": {
            // The filters in the list are the ones being 'filtered out'
            const clickedFilter = action.payload;
            const { activeFilters, allFilters } = state;

            // If !clickedFilter, it's a reset
            if (!clickedFilter) {
                return {
                    ...state,
                    activeFilters: [],
                };
            }

            const noFiltersApplied = !activeFilters.length;
            const removingLastOption =
                activeFilters.length === allFilters.length - 1 &&
                !activeFilters.includes(clickedFilter);

            // If no filters applied
            // Filter out everything other than the clicked one
            if (noFiltersApplied) {
                return {
                    ...state,
                    activeFilters: allFilters.filter(f => f !== clickedFilter),
                };
            }
            // If we're removing the last option, unfilter everything
            else if (removingLastOption) {
                return {
                    ...state,
                    activeFilters: [],
                };
            }
            // Else, just toggle the clicked filter
            else {
                const newFilters = activeFilters.includes(action.payload)
                    ? activeFilters.filter(d => d !== action.payload)
                    : activeFilters.concat(action.payload);
                return { ...state, activeFilters: newFilters };
            }
        }
        case "ACTIVE_PAGE:SET": {
            return { ...state, activePage: action.payload };
        }
        case "MAP_TYPE:SET": {
            return { ...state, mapType: action.payload };
        }
        case "MAP:SET_BASEMAP": {
            return { ...state, basemap: action.payload };
        }
        case "IS_MULTIPLE:SET": {
            return {
                ...state,
                isMultiple: action.payload ? true : false,
                activeMultipleProject: action.payload,
                activeProject: null,
                activeFeature: null,
            };
        }

        default:
            return state;
    }
};

export const selectActiveFeature = s => s.activeFeature;
export const selectAriaLiveRegionContents = s => s.ariaLiveRegionContents;
export const selectSearchBarVisible = s => s.searchBarVisible;
export const selectSearchedLocation = s => s.searchedLocation;
export const selectActiveProject = s => s.activeProject;
export const selectActiveMultipleProject = s => s.activeMultipleProject;
export const selectActiveFilters = s => s.activeFilters;
export const selectActivePage = s => s.activePage;
export const selectIsFramed = s => s.isFramed;
export const selectIsMultiple = s => s.isMultiple;
export const selectMapType = s => s.mapType;
export const selectViewingFund = s => s.viewingFund;
export const selectIsInternal = s => s.internal;
export const selectBasemap = s => s.basemap;
export const selectZoomToNsw = s => s.zoomToNsw;



// WEBPACK FOOTER //
// ./src/reducers/ui.js